export default __webpack_public_path__ + "static/media/shangpin.c5f5a11a.png";